"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = ajax;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _formatGetUrl = _interopRequireDefault(require("./formatGetUrl"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var api = process.env.MAINAPI;

function ajax(config) {
  var method = config.method ? config.method.toUpperCase() : 'GET';
  var url,
      customConfig = {};

  var headers = _objectSpread({}, config.headers);

  if (method === 'GET') {
    url = (0, _formatGetUrl["default"])(config.url, config.data);
  } else {
    url = config.url;
    customConfig.body = JSON.stringify(config.data);
  } // Remove config properties that are formatted by this function


  delete config.url;
  delete config.data;
  delete config.method;
  delete config.headers; // If a relative URL and we have an API, append it

  if (typeof api !== 'undefined' && api != '' && url.charAt(0) === '/') {
    url = api + url;
  }

  return fetch(url, _objectSpread(_objectSpread({
    method: method,
    credentials: 'same-origin',
    headers: new Headers(_objectSpread({
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      'X-Requested-With': 'XMLHttpRequest'
    }, headers))
  }, customConfig), config));
}

;